import axios from 'axios'

export default function Ajax(ajaxBody, ajaxUrl, resolve, method) {
  const url = 'http://172.32.4.155:8000/api/'
  axios({
    method: method,
    url: url + ajaxUrl,
    data: ajaxBody,
    headers: {
      Authorization: `Bearer ${localStorage.userToken}`,
      'Content-Type': 'application/json',
    },
  })
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      console.log(error)
    })
}
